export default (props = {}) => {
  const { containerName } = props;
  return (containerName && typeof containerName  === 'string') ? { containerName } : null;
};
